import { render, staticRenderFns } from "./SchoolTabs.vue?vue&type=template&id=108519f6&scoped=true&"
import script from "./SchoolTabs.vue?vue&type=script&lang=js&"
export * from "./SchoolTabs.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTabs.vue?vue&type=style&index=0&id=108519f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108519f6",
  null
  
)

export default component.exports